module.exports = __webpack_public_path__ + "ebbcbd0a719d3a44fe3444e0816bfc56.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dtg-tshirt-white-design.png
// module id = 679
// module chunks = 0